import React, { useRef, useState } from "react";
import { use } from "react";
import { Container, Row, Col, Button, Form } from "react-bootstrap";

const TechniquesSection = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobile: "",
    course: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };


    const formRef = useRef(null);
  

  const handleScrollToForm = () => {
    formRef.current?.scrollIntoView({ behavior: "smooth" });
  };  

  const handleSubmit = (e) => {
    e.preventDefault();

    const { name, email, mobile, course, message } = formData;
    const phoneNumber = "9445744663"; // 🔹 Replace with your WhatsApp number (no +)

    const whatsappMsg = `Hello, I would like to enquire about the Baking Course.%0A
*Name:* ${name}%0A
*Email:* ${email}%0A
*Mobile:* ${mobile}%0A
*No. of Recipes:* ${course}%0A
*Name of the Recipes:* ${message}`;

    window.open(`https://wa.me/${phoneNumber}?text=${whatsappMsg}`, "_blank");
  };

  return (
    <>
      {/* Techniques Section */}
      <section className="bg-light py-5 text-center">
        <Container>
          <h2 className="fw-bold mb-4">Workshop Highlights</h2>
          <Row className="justify-content-center">
            <Col md={3} className="mb-4">
              <div className="p-4 shadow-sm bg-white rounded-4">
                <h5 className="fw-bold mb-3">Hands-On Learning</h5>
                <ul className="list-unstyled text-center">
                  <li>100% Practical Sessions</li>
                  <li>Step-by-Step Guidance</li>
                  {/* <li>Butter Cream</li>
                  <li>Truffles</li>
                  <li>Ganache</li> */}
                </ul>
              </div>
            </Col>
            <Col md={3} className="mb-4">
              <div className="p-4 shadow-sm bg-white rounded-4">
                <h5 className="fw-bold mb-3">Course Info</h5>
                <ul className="list-unstyled text-center">
                  <li>Timing: 10 AM – 4 PM</li>
                  <li>Intensive Project Guidance</li>
                  {/* <li>Cake Layering</li>
                  <li>Cake Stacking</li> */}
                </ul>
              </div>
            </Col>
          </Row>
          <Button variant="danger" className="mt-4 px-4 py-2 rounded-3" onClick={handleScrollToForm}>
            Register Now
          </Button>
        </Container>
      </section>

      {/* Banner */}
      <div
        className="text-center text-light py-5"
        style={{
          backgroundImage:
            "url('/images/chefes.jpg')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          position: "relative",
        }}
      >
        <div
          style={{
            background: "rgba(0,0,0,0.5)",
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
          }}
        ></div>
        <h3 className="position-relative fw-bold">Your Chef Journey Begins Here!</h3>
      </div>

      {/* Enquiry Form Section */}
      <section className="py-5" ref={formRef}>
        <Container>
          <Row className="align-items-center justify-content-center g-4">
            <Col md={5} className="text-center mx-5">
              <img
                src="/images/diploma.jpg"
                alt="Students Practicing"

                className="img-fluid img-thumbnail shadow"
              />
            </Col>
            <Col md={5}>
              <h3 className="fw-bold mb-3 text-dark">Enquiry Now</h3>
              <Form onSubmit={handleSubmit}>
                <Form.Group className="mb-3">
                  <Form.Control
                    type="text"
                    placeholder="Name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Control
                    type="email"
                    placeholder="Email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Control
                    type="text"
                    placeholder="Mobile"
                    name="mobile"
                    value={formData.mobile}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Select
                    name="course"
                    value={formData.course}
                    onChange={handleChange}
                    required
                  >
                    <option value="">Select No. of Recipes</option>
                    <option value="Pick 2">Pick 4</option>
                    <option value="Pick 4">Pick 6</option>
                    <option value="Pick 6">Pick 10</option>
                  </Form.Select>
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Control
                    as="textarea"
                    rows={3}
                    placeholder="Enter the names of your selected recipes"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                  />
                </Form.Group>

                <p className="small text-muted">
                  *We promise not to disclose your personal information to third parties.
                </p>

                <Button
                  variant="warning"
                  type="submit"
                  className="fw-bold text-dark px-4"
                >
                  Submit Now
                </Button>
              </Form>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default TechniquesSection;
